// import logo from './logo.svg';
import { Route, Routes } from 'react-router-dom';
import { throttle } from 'lodash';
import Footer from './components/footer/Footer';
import { useEffect, useMemo, useState } from 'react';
import './scss/reset.css';
import './App.css';
import '../src/scss/customScrollBar.scss';
import '../src/scss/font.css';
import '../src/components/header/header.scss';
import '../src/components/footer/footer.scss';
import '../src/components/main/main.scss';
import '../src/components/popup/style.scss';
import './scss/style.scss';
import Header from './components/header/Header';
import MainVisual from './components/main/mainVisual';
import TermPersonal from './components/popup/termPersonal';
import TermEmail from './components/popup/termEmail';
import ProductPage from './pages/product/productPage';
import AboutUs from './pages/aboutUs/aboutUs';
import DownLoad from './pages/download/downLoad';
import ContactPage from './pages/contactUs/contactPage';
import axios from "axios";

function App() {

  const [noWheel, setNoWheel] = useState(false);
  const throttledScroll = useMemo(
    () =>
      throttle(() => {
        if (window.scrollY !== 0) {
          setNoWheel(true);
        } else {
          setNoWheel(false);
        }
      }, 100),
    [noWheel],
  );

  useEffect(() => {
    window.addEventListener('scroll', throttledScroll);
    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  }, [throttledScroll]);

  return (
    <>
      <Header noWheel={noWheel} setNoWheel={setNoWheel} />
      <main>
        <Routes>
          <Route path="/" element={<MainVisual />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/product/*" element={<ProductPage />} />
          <Route path="/downLoad" element={<DownLoad />} />
          <Route path="/contact-us/*" element={<ContactPage />} />
          <Route path="/popup/term-personal" element={<TermPersonal />} />
          <Route path="/popup/term-email" element={<TermEmail />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
